import { Pipe, PipeTransform } from '@angular/core';
import { DiscountMode } from '../../../../../../libs/data/src/lib/enum/discount-mode.enum';
import { ServiceChargeDto } from '@up/data';
@Pipe({
  name: 'applyServiceChargeMode'
})
export class ServiceChargeModePipe implements PipeTransform {
  public constructor() {}
  transform(serviceCharge: Partial<ServiceChargeDto>, currency?: any): string {
    if (serviceCharge) {
      return DiscountMode[serviceCharge.serviceChargeModeId] === DiscountMode[1]
        ? '%'
        : currency && currency.symbol? currency.symbol : currency;
    }
    return '';
  }
}
